import Model from '@/models/Model'

export default {
    mixins: [
        Model
    ],

    data() {
        return {
            table: 'orders',
            name: 'order',
            class: 'Modules\\Ecommerce\\Entities\\Order'
        }
    },

    methods: {
        process(order) {
            return axios({
                method: 'post',
                url: route('api.orders.process', order)
            })
            .then(response => {
                if(response.data.success) {
                    return response.data.data
                } else {
                    this.$alert(response.data.message, 'Error!', 'error')
                    return Promise.reject(response.data.message)
                }
            })
            .catch(error => {
                this.$alert(Object.values(error.response.data.errors)[0][0], 'Error!', 'error')
                return Promise.reject(Object.values(error.response.data.errors)[0][0])
            })
        },

        getFormattedStatus(status) {
            let formatted = status

            switch (status) {
                case 'created':
                    formatted = 'Pendiente'
                break

                case 'cancelled':
                    formatted = 'Cancelado'
                break

                case 'paying':
                    formatted = 'Validando pago'
                break

                case 'paid':
                    formatted = 'Pagado'
                break
            }

            return formatted
        },

        setIsCollected(order) {
            return axios({
                method: 'post',
                url: route('api.orders.set.is.collected', order),
                data: order
            })
            .then(response => {
                if(response.data.success) {
                    return response.data.data
                } else {
                    this.$alert(response.data.message, 'Error!', 'error')
                    return Promise.reject(response.data.message)
                }
            })
            .catch(error => {
                this.$alert(Object.values(error.response.data.errors)[0][0], 'Error!', 'error')
                return Promise.reject(Object.values(error.response.data.errors)[0][0])
            })
        },

        prepareResource(resource) {
            resource.require_shipping = Boolean(resource.shipping)
                ? 1
                : 0
        }
    }
}